import React, { useEffect } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import Loader from 'components/Loader';
import { AppRoutes } from 'routes/routes.enums';
import { switchToPrequalificationV2 } from 'utils/switchToPrequalificationV2';

const ResumeProcessLink = () => {
  const { search: query } = useLocation();
  const token = new URLSearchParams(query).get('token');

  useEffect(() => {
    if (token) {
      switchToPrequalificationV2(`${AppRoutes.ResumeProcess}${query}`);
    }
  }, []);

  if (token) {
    return <Loader />;
  }

  return <Navigate replace to={`${AppRoutes.Dashboard}${query}`} />;
};

export default ResumeProcessLink;
